import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import MessageById from '../common/MessageById'
import FlexColumn from '../../../../components/molecules/FlexColumn'
import ReadingListNavigation from './ReadingListNavigation'
import NextUpLink from './NextUpLink'

function ItemView ({ readingList }) {
  const { scheduleId } = useParams()
  const item = useMemo(() => {
    const match = readingList.unread.find(x => x.scheduleId === scheduleId)
    if (!match) return null

    return {
      parentInfo: {
        parentId: match.scheduleId,
        parentType: 'schedule'
      },
      messageId: match.threadMessageId
    }
  }, [readingList, scheduleId])

  return (
    <FlexColumn className='gap-md'>
      <ReadingListNavigation
        linkedList={readingList.linkedList}
        currentScheduleId={scheduleId}
      />
      <MessageById
        {...item}
        postContent={(
          <NextUpLink linkedList={readingList.linkedList} currentScheduleId={scheduleId} />
        )}
        hideMessageHeader
      />
    </FlexColumn>
  )
}

ItemView.propTypes = {
  readingList: PropTypes.object
}

export default ItemView
